export const buildEloquaExtraDataOrEmpty = (data) => {
    if (!data) {
        return {
            csmEmail: '',
            csmName: '',
            contactOwnerMeetingLink: '',
            csOwnerMeetingLink: '',
            currentCADSystem: '',
            daysLeftInTrial: '',
            isEmailPreferencesSet: false,
            isSubBlogs: false,
            isSubEvents: false,
            isSubNewsletter: false,
            isSubPremiumContent: false,
            jobTitleNormalized: '',
            productSku: '',
            productSkuAtSignup: '',
            salesOpps: 0,
            salesPersonMeetingLink: '',
            uUsageTimeL30D: 0,
            uUsageTimeTotal: 0,
        };
    }
    const result = {
        jobTitleNormalized: data.jobTitleNormalized || '',
        productSkuAtSignup: data.productSkuAtSignup || '',
        currentCADSystem: data.currentCADSystem || '',
        contactOwnerMeetingLink: data.contactOwnerMeetingLink || '',
        csOwnerMeetingLink: data.csOwnerMeetingLink || '',
        salesPersonMeetingLink: data.salesPersonMeetingLink || '',
        salesOpps: data.salesOpps || 0,
        csmName: data.csmName || '',
        csmEmail: data.csmEmail || '',
        isEmailPreferencesSet: data.isEmailPreferencesSet || false,
        isSubPremiumContent: data.isSubPremiumContent || false,
        isSubNewsletter: data.isSubNewsletter || false,
        isSubEvents: data.isSubEvents || false,
        isSubBlogs: data.isSubBlogs || false,
        productSku: data.productSku || '',
        daysLeftInTrial: data.daysLeftInTrial || '',
        uUsageTimeL30D: data.uUsageTimeL30D || 0,
        uUsageTimeTotal: data.uUsageTimeTotal || 0,
    };
    return result;
};
